// Paint the hero poster before starting decorative video. Keep one controller per
// section so visibility, shopper preferences and theme-editor unload agree.
(function () {
  function arm(v) {
    if (v.dataset.apArmed) return;
    v.dataset.apArmed = '1';
    var section = v.closest('.ap-hero');
    var poster = section.querySelector('.ap-hero__poster');
    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var connection = navigator.connection;
    var wanted = !motion.matches && !(connection && connection.saveData);
    var visible = true;
    var ready = !poster;
    var disposed = false;
    var pending = false;
    v.muted = true; v.defaultMuted = true; v.playsInline = true;

    function sync() {
      if (disposed || !wanted || !visible || document.hidden) { v.pause(); return; }
      if (!ready || pending) return;
      if (!v.getAttribute('src')) {
        var mobile = v.dataset.srcMobile;
        var source = mobile && window.matchMedia('(max-width: 749px)').matches ? mobile : v.dataset.srcDesktop;
        if (!source) return;
        v.src = source;
      }
      pending = true;
      var play = v.play();
      if (play && play.then) play.then(function () {
        pending = false;
        if (disposed || !wanted || !visible || document.hidden) v.pause();
      }).catch(function (error) {
        pending = false;
        if (disposed) return;
        if (error.name === 'AbortError') { sync(); return; }
        // Leave the poster visible when the browser blocks autoplay.
        if (wanted && visible && !document.hidden) { wanted = false; }
      });
      else pending = false;
    }
    function playing() { v.classList.add('is-playing'); }
    function preference() { if (motion.matches || (connection && connection.saveData)) wanted = false; sync(); }
    function unload(event) {
      if (!event.target.contains(section)) return;
      disposed = true;
      v.pause();
      if (observer) observer.disconnect();
      motion.removeEventListener('change', preference);
      if (connection) connection.removeEventListener('change', preference);
      document.removeEventListener('visibilitychange', sync);
      document.removeEventListener('shopify:section:unload', unload);
      v.removeEventListener('playing', playing);
    }
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      sync();
    }) : null;
    if (observer) observer.observe(section);
    v.addEventListener('playing', playing);
    motion.addEventListener('change', preference);
    if (connection) connection.addEventListener('change', preference);
    document.addEventListener('visibilitychange', sync);
    document.addEventListener('shopify:section:unload', unload);
    // decode() settles on both cached and newly loaded images. Failure must not
    // prevent video playback when the configured poster is unavailable.
    var decoded = poster && poster.decode ? poster.decode().catch(function () {}) : Promise.resolve();
    decoded.then(function () {
      requestAnimationFrame(function () { requestAnimationFrame(function () { ready = true; sync(); }); });
    });
  }
  function boot() { document.querySelectorAll('video.ap-hero__video').forEach(arm); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
